import { render } from "./UserPayment.vue?vue&type=template&id=87b0aee0"
import script from "./UserPayment.vue?vue&type=script&lang=js"
export * from "./UserPayment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__